import { NavLink } from "react-router-dom"
import { SITE_INFO } from '../configs/info'

export default function Reimbursement() {
    return (
        <>
            {/* Header Section */}
            <section className="bg-[linear-gradient(177.6deg,_rgba(180,0,0,1)_15.3%,_rgba(80,0,0,1)_91.3%)] text-white py-6 sm:py-8 md:py-10">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto pt-8">
                    <div className="text-center mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-pink-100 text-xs md:text-sm">
                            <span className="inline-block w-2 h-2 rounded-full bg-pink-400"></span>
                            {SITE_INFO.siteName}
                        </span>
                    </div>
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight bg-gradient-to-r from-white via-pink-100 to-orange-100 bg-clip-text text-transparent drop-shadow-lg">Política de Reembolso</h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mt-3">
                        <span className="text-sm text-white/80"><NavLink to="/" className="transition-all duration-500 hover:text-pink-400">Inicio</NavLink> / <span className="text-white/60">Política de Reembolso</span></span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-6 md:py-8 min-h-[80vh] comment-pricing">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                    <div className="space-y-6">
                        {/* Section 1 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">1. Derecho al reembolso</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                En {SITE_INFO.siteName}, nos comprometemos a garantizar su satisfacción. Por eso, ofrecemos una política de reembolso de 15 días para todos nuestros usuarios. Si por alguna razón no está satisfecho con nuestros servicios, puede solicitar un reembolso en un plazo de 15 días tras su compra.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">2. Condiciones de reembolso</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Para ser elegible para un reembolso, se deben cumplir las siguientes condiciones:
                            </p>
                            <ul className="list-disc list-inside pt-2 text-white/90 text-sm md:text-base">
                                <li>La solicitud debe realizarse dentro de los 15 días siguientes a la fecha de compra.</li>
                                <li>Debe proporcionar un comprobante de compra válido, como su recibo o correo electrónico de confirmación.</li>
                                <li>Los reembolsos no están disponibles si ya ha utilizado más del 50% de su período de suscripción.</li>
                            </ul>
                        </div>

                        {/* Section 3 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">3. Proceso de solicitud</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Para solicitar un reembolso, siga estos pasos:
                            </p>
                            <ol className="list-inside list-decimal pt-2 text-white/90 text-sm md:text-base">
                                <li> La solicitud debe realizarse dentro de los 15 días siguientes a la fecha de compra.</li>
                                <li> Debe proporcionar un comprobante de compra válido, como su recibo o correo electrónico de confirmación.</li>
                                <li> Los reembolsos no están disponibles si ya ha utilizado más del 50% de su período de suscripción.</li>
                            </ol>
                        </div>

                        {/* Section 4 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">4. Método de reembolso</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Si su solicitud de reembolso es aprobada, el monto se devolverá a través del mismo método de pago utilizado en su compra. El tiempo de procesamiento puede variar según su proveedor de pago.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">5. Contáctenos</h2>
                            <p className="text-sm md:text-base leading-relaxed mb-4 text-white/80">
                                Para cualquier pregunta sobre esta política de privacidad o para ejercer sus derechos,
                                puede contactarnos a través de:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm md:text-base text-white/90">
                                <li>Correo electrónico: <span className="text-pink-300">contact@tvcielo.com</span></li>
                                <li>
                                    WhatsApp:{" "}
                                    <a
                                        href="https://wa.me/33644657251"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-pink-300 underline hover:text-pink-400"
                                    >
                                        Haga clic aquí para contactarnos
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="mt-10 pt-6 border-t border-white/10 text-white">
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Gracias por elegir {SITE_INFO.siteName}. Estamos orgullosos de garantizar su privacidad y de
                                ofrecerle un servicio de alta calidad sin comprometer su seguridad o anonimato.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
